import Http from "./base-http"
import queryString from 'querystring'

class Store extends Http {
  getPayrollData(storeId, options = {}) {
    return this.get(`${storeId}/payroll?${queryString.stringify(options)}`)
  }
  getWeatherDetails(storeId){
    return this.get(`${storeId}/weather`)
  }
  getUpcommingEmployeeSchedule({ storeId, date }) {
    return this.get(`${storeId}/upcomming-schedules/date/${date}`)
  }
  getAttendanceSummary(storeId) {
    return this.get(`${storeId}/attendance/summary`)
  }
}

const store = new Store({ modelUrlPrefix : "store", timeout : 30000 })

export default store
